import React from 'react'
import { useLanguage } from '../src/LanguageContext'

export const LanguageSelector = () => {
  const { language, changeLanguage } = useLanguage()

  const languages = [
    { code: 'en', label: 'EN', name: 'English' },
    { code: 'nl', label: 'NL', name: 'Nederlands' },
    { code: 'de', label: 'DE', name: 'Deutsch' },
    { code: 'ar', label: 'AR', name: 'العربية' },
  ]

  return (
    <div className="lang-selector">
      {languages.map((lang) => (
        <button
          key={lang.code}
          className={`lang-btn ${language === lang.code ? 'lang-active' : ''}`}
          onClick={() => changeLanguage(lang.code)}
          title={lang.name}
        >
          {lang.label}
        </button>
      ))}
    </div>
  )
}

export default LanguageSelector